import { fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";

export const fetchUserData = async () => {
    const { userId } = await getCurrentUser();
    const { email, given_name: firstName, family_name: lastName } = await fetchUserAttributes();
    return { userId, email, firstName, lastName };
};
